import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, input, signal } from "@angular/core";

/**
 * A map-control button (sized to match Leaflet's zoom controls) that expands
 * into a popover with projected content. Closes on outside clicks.
 */
@Component({
  selector: "iotnet-map-popover",
  templateUrl: "iotnet-map-popover.html",
  styleUrls: ["./iotnet-map-popover.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class IotnetMapPopover {
  public readonly icon = input.required<string>();
  public readonly buttonTitle = input("");
  /** Highlights the button (blue) to signal it has an effect, e.g. active filters. */
  public readonly highlighted = input(false);
  /** Which button edge the panel aligns to; "bottom" suits buttons near the map's bottom. */
  public readonly attach = input<"top" | "bottom">("top");

  protected readonly expanded = signal(false);

  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);

  @HostListener("document:click", ["$event.target"])
  protected onDocumentClick(target: EventTarget | null): void {
    if (this.expanded() && target instanceof Node && !this.element.nativeElement.contains(target)) {
      this.expanded.set(false);
    }
  }

  protected toggleExpanded(): void {
    this.expanded.update((expanded) => !expanded);
  }
}
